import { IonButton, IonIcon } from '@ionic/react';
import { backspaceOutline, trailSign } from 'ionicons/icons';
import React, { useContext } from 'react';
import { AppContext } from 'context/app.context';
import { Section } from 'models/questionnaire.model';
import { QuestionnaireActionTypes } from 'reducers/questionnaire.reducer';
import './ConditionalForm.css'

interface ConditionalLogicProps {
    section?: Section,
    isBack?: boolean
}

const ConditionalLogicButton: React.FC<ConditionalLogicProps> = (props) => {


    const appContext = useContext(AppContext);

    const setConditionalLogicMode = () => {
        const payload = {
            Section: props.section,
            ConditionalLogicMode: !appContext.questionnaire?.ConditionalLogicMode
        }
        appContext.updateQuestionnaire(QuestionnaireActionTypes.SET_CONDITIONAL_MODE, payload);
    }


    return (
        <IonButton fill="clear" onClick={() => { setConditionalLogicMode() }}>
            {!props.isBack && (
                <React.Fragment>
                    <b>Conditions</b>
                    <IonIcon className="condition-icon" icon={trailSign} />
                </React.Fragment>

            )}
            {props.isBack && (
                <React.Fragment>
                    <b>Go back</b>
                    <IonIcon icon={backspaceOutline} />
                </React.Fragment>

            )}

        </IonButton >
    )
}

export default ConditionalLogicButton